export default {
  Project: class Project {
    constructor(use_type, status) {
      this.use_type = use_type;
      this.status = status;
    }
  },

  Stage: class Stage {
    constructor(use_type, status, project_status) {
      this.use_type = use_type;
      this.status = status;
      this.project = {
        status: project_status
      }
    }
  },
  Task: class Task {
    constructor(use_type, status) {
      this.use_type = use_type;
      this.status = status;
    }
  },
}
